import {
  GET_VEHICLE_MAKE_COUNT,
  GET_VEHICLE_MAKE_COUNT_SUCCESS,
  GET_VEHICLE_MAKE_COUNT_FAILURE,
  SEARCH_VEHICLE,
  SEARCH_VEHICLE_SUCCESS,
  SEARCH_VEHICLE_FAILURE,
  GET_PRODUCTS,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAILURE,
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILURE,
  GET_SPECIFICATIONS,
  GET_SPECIFICATIONS_SUCCESS,
  GET_SPECIFICATIONS_FAILURE,
  GET_PRICE,
  GET_PRICE_SUCCESS,
  GET_PRICE_FAILURE,
  ADD_PRODUCT_TO_BASKET,
  ADD_PRODUCT_TO_BASKET_SUCCESS,
  ADD_PRODUCT_TO_BASKET_FAILURE,
  PLACE_ORDER,
  PLACE_ORDER_SUCCESS,
  PLACE_ORDER_FAILURE,
  GET_PROMOTIONAL_API_DATA,
  GET_PROMOTIONAL_API_DATA_SUCCESS,
  GET_PROMOTIONAL_API_DATA_FAILURE,
  GET_VEHICLE,
  GET_VEHICLE_SUCCESS,
  GET_VEHICLE_FAILED,
  GET_STOCK_RECORD,
  GET_STOCK_RECORD_SUCCESS,
  GET_STOCK_RECORD_FAILURE,
  GET_SHIPPING_METHODS,
  GET_SHIPPING_METHODS_SUCCESS,
  GET_SHIPPING_METHODS_FAILURE,
  SEARCH_ITEM,
  SEARCH_ITEM_SUCCESS,
  SEARCH_ITEM_FAILURE,
  GET_ITEM,
  GET_ITEM_SUCCESS,
  GET_ITEM_FAILED,
  POST_CONTENT,
  POST_CONTENT_SUCCESS,
  POST_CONTENT_FAILURE,
  GET_PRODUCT_TYPE,
  GET_PRODUCT_TYPE_SUCCESS,
  GET_PRODUCT_TYPE_FAILURE,
  CREATE_PRODUCT,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAILURE,
  GET_CONTENT,
  GET_CONTENT_SUCCESS,
  GET_CONTENT_FAILURE,
  GET_VENDOR_PRODUCTS,
  GET_VENDOR_PRODUCTS_SUCCESS,
  GET_VENDOR_PRODUCTS_FAILURE,
  CREATE_LECTURE,
  CREATE_LECTURE_SUCCESS,
  CREATE_LECTURE_FAILURE,
  UPLOAD_IMAGE,
  UPLOAD_IMAGE_SUCCESS, UPLOAD_IMAGE_FAILURE,
  GET_ALL_PRODUCTS, GET_ALL_PRODUCTS_SUCCESS, GET_ALL_PRODUCTS_FAILURE,
  DELETE_CONTENT, DELETE_CONTENT_SUCCESS, DELETE_CONTENT_FAILURE
} from "../constants";

const initialState = {
  vehicleMakeCountSuccess: null,
  vehicleMakeCountError: null,
  vehicleMakeCountLoader: false,

  searchVehicleSuccess: null,
  searchVehicleError: null,
  searchVehicleLoader: false,

  searchItemSuccess: null,
  searchItemError: null,
  searchItemLoader: false,

  getProductsSuccess: null,
  getProductsError: null,
  getProductsLoader: false,

  getAllProductsSuccess: null,
  getAllProductsError: null,
  getAllProductsLoader: false,

  getCountriesSuccess: null,
  getCountriesError: null,
  getCountriesLoader: false,

  getSpecificationsSuccess: null,
  getSpecificationsError: null,
  getSpecificationsLoader: false,
  
  getPriceSuccess: null,
  getPriceError: null,

  getStockRecordSuccess: null,
  getStockRecordError: null,
  
  addProductToBasketSuccess: null,
  addProductToBasketError: null,
  addProductToBasketLoader: false,

  placeOrderSuccess: null,
  placeOrderError: null,
  placeOrderLoader: false,
  //
  // getBestDealsSuccess: null,
  // getBestDealsError: null,
  // getBestDealsLoader: false,
  
  getPromotionalApiDataSuccess: null,
  getPromotionalApiDataError: null,
  getPromotionalApiDataLoader: false,

  getVehicleDetail: null,
  getVehicleDetailError: null,
  getVehicleDetailLoader: false,

  getItemDetail: null,
  getItemDetailError: null,
  getItemDetailLoader: false,

  getShippingMethodsSuccess: null,
  getShippingMethodsError: null,
  getShippingMethodsLoader: false,

  postContentSuccess: null,
  postContentError: null,
  postContentLoader: false,

  getContentSuccess: null,
  getContentError: null,
  getContentLoader: false,

  deleteContentSuccess: null,
  deleteContentError: null,
  deleteContentLoader: false,
  
  getProductTypeSuccess: null,
  getProductTypeError: null,
  getProductTypeLoader: false,

  createProductSuccess: null,
  createProductTypeError: null,
  createProductLoader: false,

  getVendorProductsSuccess: null,
  getVendorProductsError: null,
  getVendorProductsLoader: false,

  createLectureSuccess: null,
  createLectureError: null,
  createLectureLoader: false,

  uploadImageSuccess: null,
  uploadImageError: null,
  uploadImageLoader: false

};

export default function vehicleReducer(state = initialState, action) {
  switch (action.type) {
    // Vehicle Make Count
    case GET_VEHICLE_MAKE_COUNT:
      return {
        ...state,
        vehicleMakeCountLoader: true,
        vehicleMakeCountSuccess: null,
        vehicleMakeCountError: null
      };

    case GET_VEHICLE_MAKE_COUNT_SUCCESS:
      return {
        ...state,
        vehicleMakeCountLoader: false,
        vehicleMakeCountSuccess: action.payload,
        vehicleMakeCountError: null
      };

    case GET_VEHICLE_MAKE_COUNT_FAILURE:
      return {
        ...state,
        vehicleMakeCountLoader: false,
        vehicleMakeCountSuccess: null,
        vehicleMakeCountError: action.error
      };

    // Search Vehicle
    case SEARCH_VEHICLE:
      return {
        ...state,
        searchVehicleLoader: true,
        searchVehicleSuccess: null,
        searchVehicleError: null
      };

    case SEARCH_VEHICLE_SUCCESS:
      return {
        ...state,
        searchVehicleLoader: false,
        searchVehicleSuccess: action.payload,
        searchVehicleError: null
      };

    case SEARCH_VEHICLE_FAILURE:
      return {
        ...state,
        searchVehicleLoader: false,
        searchVehicleSuccess: null,
        searchVehicleError: action.error
      };

    // Search Item
    case SEARCH_ITEM:
      return {
        ...state,
        searchItemLoader: true,
        searchItemSuccess: null,
        searchItemError: null
      };

    case SEARCH_ITEM_SUCCESS:
      return {
        ...state,
        searchItemLoader: false,
        searchItemSuccess: action.payload,
        searchItemError: null
      };

    case SEARCH_ITEM_FAILURE:
      return {
        ...state,
        searchItemLoader: false,
        searchItemSuccess: null,
        searchItemError: action.error
      };

    // Get Products
    case GET_PRODUCTS:
      return {
        ...state,
        getProductsLoader: true,
        getProductsSuccess: null,
        getProductsError: null
      };

    case GET_PRODUCTS_SUCCESS:
      return {
        ...state,
        getProductsSuccess: action.payload,
        getProductsError: null
      };

    case GET_PRODUCTS_FAILURE:
      return {
        ...state,
        getProductsLoader: false,
        getProductsSuccess: null,
        getProductsError: action.error
      };

    // Get All Products
    case GET_ALL_PRODUCTS:
      return {
        ...state,
        getAllProductsLoader: true,
        getAllProductsSuccess: null,
        getAllProductsError: null
      };

    case GET_ALL_PRODUCTS_SUCCESS:
      return {
        ...state,
        getAllProductsLoader: false,
        getAllProductsSuccess: action.payload,
        getProductsError: null
      };

    case GET_ALL_PRODUCTS_FAILURE:
      return {
        ...state,
        getAllProductsLoader: false,
        getAllProductsSuccess: null,
        getAllProductsError: action.error
      };

    // Get Countries
    case GET_COUNTRIES:
      return {
        ...state,
        getCountriesSuccess: null,
        getCountriesError: null
      };

    case GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        getCountriesSuccess: action.payload,
        getCountriesError: null
      };

    case GET_COUNTRIES_FAILURE:
      return {
        ...state,
        getCountriesSuccess: null,
        getCountriesError: action.error
      };

    // Get Specifications
    case GET_SPECIFICATIONS:
      return {
        ...state,
        getSpecificationsSuccess: null,
        getSpecificationsError: null
      };

    case GET_SPECIFICATIONS_SUCCESS:
      return {
        ...state,
        getSpecificationsSuccess: action.payload,
        getSpecificationsError: null
      };

    case GET_SPECIFICATIONS_FAILURE:
      return {
        ...state,
        getSpecificationsSuccess: null,
        getSpecificationsError: action.error
      };

    // Get Price
    case GET_PRICE:
      return {
        ...state,
        getPriceSuccess: null,
        getPriceError: null
      };

    case GET_PRICE_SUCCESS:
      return {
        ...state,
        getProductsLoader: false,
        getPriceSuccess: action.payload,
        getPriceError: null
      };

    case GET_PRICE_FAILURE:
      return {
        ...state,
        getProductsLoader: false,
        getPriceSuccess: null,
        getPriceError: action.error
      };

    // Get Stock Record
    case GET_STOCK_RECORD:
      return {
        ...state,
        getStockRecordSuccess: null,
        getStockRecordError: null
      };

    case GET_STOCK_RECORD_SUCCESS:
      return {
        ...state,
        getProductsLoader: false,
        getStockRecordSuccess: action.payload,
        getStockRecordError: null
      }

    case GET_STOCK_RECORD_FAILURE:
      return {
        ...state,
        getProductsLoader: false,
        getStockRecordSuccess: null,
        getStockRecordError: action.error
      }


    // Add Product To Basket
    case ADD_PRODUCT_TO_BASKET:
      return {
        ...state,
        addProductToBasketLoader: true,
        addProductToBasketSuccess: null,
        addProductToBasketError: null
      };

    case ADD_PRODUCT_TO_BASKET_SUCCESS:
      return {
        ...state,
        addProductToBasketLoader: false,
        addProductToBasketSuccess: action.payload,
        addProductToBasketError: null
      };

    case ADD_PRODUCT_TO_BASKET_FAILURE:
      return {
        ...state,
        addProductToBasketLoader: false,
        addProductToBasketSuccess: null,
        addProductToBasketError: action.error
      };

    case PLACE_ORDER:
      return {
        ...state,
        placeOrderLoader: true,
        placeOrderSuccess: null,
        placeOrderError: null
      };

    case PLACE_ORDER_SUCCESS:
      return {
        ...state,
        placeOrderLoader: false,
        placeOrderSuccess: action.payload,
        placeOrderError: null
      };

    case PLACE_ORDER_FAILURE:
      return {
        ...state,
        placeOrderLoader: false,
        placeOrderSuccess: null,
        placeOrderError: action.error
      }

    // Get Best Deals
    // case GET_BEST_DEALS:
    //   return {
    //     ...state,
    //     getBestDealsLoader: true,
    //     getBestDealsSuccess: null,
    //     getBestDealsError: null
    //   };
    //
    // case GET_BEST_DEALS_SUCCESS:
    //   return {
    //     ...state,
    //     getBestDealsLoader: false,
    //     getBestDealsSuccess: action.payload,
    //     getBestDealsError: null
    //   };
    //
    // case GET_BEST_DEALS_FAILURE:
    //   return {
    //     ...state,
    //     getBestDealsLoader: false,
    //     getBestDealsSuccess: null,
    //     getBestDealsError: action.error
    //   };

    // Get Promotional Api Data
    case GET_PROMOTIONAL_API_DATA:
      return {
        ...state,
        getPromotionalApiDataLoader: true,
        getPromotionalApiDataSuccess: null,
        getPromotionalApiDataError: null
      };

    case GET_PROMOTIONAL_API_DATA_SUCCESS:
      return {
        ...state,
        getPromotionalApiDataLoader: false,
        getPromotionalApiDataSuccess: action.payload,
        getPromotionalApiDataError: null
      };

    case GET_PROMOTIONAL_API_DATA_FAILURE:
      return {
        ...state,
        getPromotionalApiDataLoader: false,
        getPromotionalApiDataSuccess: null,
        getPromotionalApiDataError: action.error
      };

    case GET_SHIPPING_METHODS:
      return {
        ...state,
        getShippingMethodsLoader: true,
        getShippingMethodsSuccess: null,
        getShippingMethodsError: null,
      };

    case GET_SHIPPING_METHODS_SUCCESS:
      return {
        ...state,
        getShippingMethodsLoader: false,
        getShippingMethodsSuccess: action.payload,
        getShippingMethodsError: null
      }

    case GET_SHIPPING_METHODS_FAILURE:
      return {
        ...state,
        getShippingMethodsLoader: false,
        getShippingMethodsSuccess: null,
        getShippingMethodsError: action.error
      }

    case GET_VEHICLE: {
      return {
        ...state,
        getVehicleDetail: null,
        getVehicleDetailError: null,
        getVehicleDetailLoader: true
      }
    }

    case GET_VEHICLE_SUCCESS: {
      return {
        ...state,
        getVehicleDetail: action.payload,
        getVehicleDetailError: null,
        getVehicleDetailLoader: false
      }
    }

    case GET_VEHICLE_FAILED: {
      return {
        ...state,
        getVehicleDetail: null,
        getVehicleDetailError: true,
        getVehicleDetailLoader: false
      }
    }

    case GET_ITEM: {
      return {
        ...state,
        getItemDetail: null,
        getItemDetailError: null,
        getItemDetailLoader: true
      }
    }

    case GET_ITEM_SUCCESS: {
      return {
        ...state,
        getItemDetail: action.payload,
        getItemDetailError: null,
        getItemDetailLoader: false
      }
    }

    case GET_ITEM_FAILED: {
      return {
        ...state,
        getItemDetail: null,
        getItemDetailError:action.error,
        getItemDetailLoader: false
      }
    }

    case POST_CONTENT: {
      return {
        ...state,
        postContentSuccess: null,
        postContentError: null,
        postContentLoader: true
      }
    }

    case POST_CONTENT_SUCCESS: {
      return {
        ...state,
        postContentSuccess: action.payload,
        postContentError: null,
        postContentLoader: false
      }
    }

    case POST_CONTENT_FAILURE: {
      return {
        ...state,
        postContentSuccess: null,
        postContentError: action.error,
        postContentLoader: false
      }
    }

    case GET_CONTENT: {
      return {
        ...state,
        getContentSuccess: null,
        getContentError: null,
        getContentLoader: true
      }
    }

    case GET_CONTENT_SUCCESS: {
      return {
        ...state,
        getContentSuccess: action.payload,
        getContentError: null,
        getContentLoader: false
      }
    }

    case GET_CONTENT_FAILURE: {
      return {
        ...state,
        getContentSuccess: null,
        getContentError: action.error,
        getContentLoader: false
      }
    }

    case GET_PRODUCT_TYPE: {
      return {
        ...state,
        getProductTypeSuccess: null,
        getProductTypeError: null,
        getProductTypeLoader: true
      };
    }

    case GET_PRODUCT_TYPE_SUCCESS: {
      return {
        ...state,
        getProductTypeSuccess: action.payload,
        getProductTypeError: null,
        getProductTypeLoader: false
      };
    }

    case GET_PRODUCT_TYPE_FAILURE: {
      return {
        ...state,
        getProductTypeSuccess: null,
        getProductTypeError: action.error,
        getProductTypeLoader: false
      };
    }

    case CREATE_PRODUCT: {
      return {
        ...state,
        createProductSuccess: null,
        createProductError: null,
        createProductLoader: true
      };
    }

    case CREATE_PRODUCT_SUCCESS: {
      return {
        ...state,
        createProductSuccess: action.payload,
        createProductError: null,
        createProductLoader: false
      };
    }

    case CREATE_PRODUCT_FAILURE: {
      return {
        ...state,
        createProductSuccess: null,
        createProductError: action.error,
        createProductLoader: false
      };
    }

    case GET_VENDOR_PRODUCTS: {
      return {
        ...state,
        getVendorProductsSuccess: null,
        getVendorProductsError: null,
        getVendorProductsLoader: true
      };
    }

    case GET_VENDOR_PRODUCTS_SUCCESS: {
      return {
        ...state,
        getVendorProductsSuccess: action.payload,
        getVendorProductsError: null,
        getVendorProductsLoader: false
      };
    }

    case GET_VENDOR_PRODUCTS_FAILURE: {
      return {
        ...state,
        getVendorProductsSuccess: null,
        getVendorProductsError: action.error,
        getVendorProductsLoader: false
      };
    }

    case CREATE_LECTURE: {
      return  {
        ...state,
        createLectureSuccess: null,
        createLectureError: null,
        createLectureLoader: true
      }
    }

    case CREATE_LECTURE_SUCCESS: {
      return  {
        ...state,
        createLectureSuccess: action.payload,
        createLectureError: null,
        createLectureLoader: false
      }
    }


    case CREATE_LECTURE_FAILURE: {
      return  {
        ...state,
        createLectureSuccess: null,
        createLectureError: action.error,
        createLectureLoader: false
      }
    }

    case UPLOAD_IMAGE: {
      return {
        ...state,
        uploadImageSuccess: null,
        uploadImageError: null,
        uploadImageLoader: true
      }
    }

    case UPLOAD_IMAGE_SUCCESS: {
      return {
        ...state,
        uploadImageSuccess: action.payload,
        uploadImageError: null,
        uploadImageLoader: false
      }
    }

    case UPLOAD_IMAGE_FAILURE: {
      return {
        ...state,
        uploadImageSuccess: null,
        uploadImageError: action.error,
        uploadImageLoader: false
      }
    }

    case DELETE_CONTENT: {
      return {
        ...state,
        deleteContentSuccess: null,
        deleteContentError: null,
        deleteContentLoader: true,
      }
    }

    case DELETE_CONTENT_SUCCESS: {
      return {
        ...state,
        deleteContentSuccess: action.payload,
        deleteContentError: null,
        deleteContentLoader: false,
      }
    }

    case DELETE_CONTENT_FAILURE: {
      return {
        ...state,
        deleteContentSuccess: null,
        deleteContentError: action.error,
        deleteContentLoader: false,
      }
    }


    default:
      return state;
  }
}
